import ModelActionsService from 'services/storageModelActions/ModelActionsService';
import IModelActionsService from './IModelActionsService';
import { CreateServicePackageRequestDTO, ServicePackageResponseDTO } from 'typings/dto/servicePackage';

export default class ServicePackageActionsService
  extends ModelActionsService<ServicePackage, CreateServicePackageRequestDTO, ServicePackageResponseDTO>
  implements IModelActionsService<ServicePackage, CreateServicePackageRequestDTO, ServicePackageResponseDTO> { }
